import React, { Component } from 'react';
import api from '../../common/api';
import { responseToTableValues } from './utils';
import YetToSettle from '../../components/tables/YetToSettle';

export default class YetToSettleContainer extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            rows: [], 
            isLoading: true
        };
    }

    componentDidMount() {
        const query = encodeURIComponent(JSON.stringify({ status: "YetToSettle" }));

        api.get(`/api/clientPurchases/clientsWithDifferentStatus?filter=${query}`)
            .then(({ clients: engagements }) => {
                // Transform into table format
                const rows = engagements.map(responseToTableValues);

                this.setState({ rows, isLoading: false });
            });
    }

    render() {
        const { rows, isLoading } = this.state;
        return <YetToSettle isLoading={isLoading} rows={rows} />;
    }
}
